import React, { useEffect, useState } from "react";
import axios from "axios";
import endPoint from "../redux/EndPoint/endpoint";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";

function Getaddress() {
  const navigate = useNavigate()
  const [addresses, setAddresses] = useState([]);
  const [checkoutData, setCheckoutData] = useState(null);
  const userId = localStorage.getItem("userId");
  const [loading, setLoading] = useState(false);
  const [shippingCost, setShippingCost] = useState(0);
  const [paymentMethod, setPaymentMethod] = useState("COD");
  const location = useLocation();
  const { address } = location.state || {};
  const [isNotProcessed, setIsNotProcessed] = useState(false);

  useEffect(() => {
    const fetchShippingCost = async () => {
      try {
        const response = await axios.get(
          "https://www.bharatcod.com/admin/getDeliveryCost",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          }
        );

        const cost = response.data.deliveryCost.shippingCost;
        setShippingCost(cost);
      } catch (error) {
        console.error("Error fetching shipping cost:", error);
      }
    };
    fetchShippingCost();
  }, []);

  useEffect(() => {
    const fetchAddresses = async () => {
      try {
        if (!userId) {
          console.error("User ID not found");
          return;
        }

        const response = await axios.get(
          `https://www.bharatcod.com/user/get-user-address/${userId}`
        );

        setAddresses(response.data);
        if (response.data && response.data.length > 0) {
          const firstAddressId = response.data[0]._id;

          if (firstAddressId) {
            localStorage.setItem("addressId", firstAddressId);
          }
        } else {
          console.warn("⚠️ No addresses found to save addressId");
        }
      } catch (error) {
        console.error("Error fetching addresses:", error);
      }
    };

    fetchAddresses();
  }, [userId]);


  const generateSignatureFrontend = (paymentPayload, secretKey) => {
    const sortedValues = Object.entries(paymentPayload)
      .filter(([key, value]) => {
        if (key === "subMerchantPayInfo") return true;
        return value !== null && value !== undefined;
      })
      .sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
      .map(([key, value]) => {
        if (
          key === "subMerchantPayInfo" &&
          (value === null || value === undefined)
        ) {
          return "null";
        }
        return value;
      })
      .join("");

    const stringToHash = sortedValues + secretKey;
    const hash = CryptoJS.SHA256(stringToHash);
    return hash.toString(CryptoJS.enc.Hex);
  };

  const submitToFreecharge = (url, payload) => {
    const form = document.createElement("form");
    form.method = "POST";
    form.action = url;

    Object.keys(payload).forEach((key) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = payload[key];
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  };

  // PayU Checkout Handler Function
  const redirectToPayU = (payuData) => {
    // 1. Ek hidden HTML form create karo
    const form = document.createElement("form");
    form.setAttribute("method", "POST");
    form.setAttribute("action", payuData.action); // PayU Payment URL

    // 2. Saare payuData fields ko hidden inputs bana kar form me dalo
    for (const key in payuData) {
      if (key !== "action" && payuData[key] !== undefined && payuData[key] !== null) {
        const input = document.createElement("input");
        input.setAttribute("type", "hidden");
        input.setAttribute("name", key);
        input.setAttribute("value", payuData[key]);
        form.appendChild(input);
      }
    }

    // 3. Form ko body me daal kar auto-submit kar do
    document.body.appendChild(form);
    form.submit();
  };

  const handlePlaceOrder = async () => {
    const storedAddressId = localStorage.getItem("addressId");
    const storedCheckoutData = JSON.parse(localStorage.getItem("checkoutData"));


    if (!storedCheckoutData?.orderID) {
      toast.info("Error: Checkout data missing");
      return;
    }

    // --- 1. VALIDATION ---
    if (!storedAddressId) {
      toast.info("Error: Address not selected");
      return;
    }

    try {
      setLoading(true);
      const Token = localStorage.getItem("authToken");

      const selectedAddress = addresses?.find(
        (item) => item._id === storedAddressId
      );

      const orderData = {
        orderID: storedCheckoutData.orderID,
        totalPrice:
          Number(storedCheckoutData.totalPrice) +
          Number(shippingCost || 0),
        platform: "website",
        addressId: storedAddressId,
        paymentMethod: paymentMethod,
        email: address?.email || selectedAddress?.email || "",
        orderItems: (storedCheckoutData.orderItems || []).map((item) => ({
          productId: item.productId,
          quantity: item.quantity,
        })),
      };

      console.log("📦 Sending Order Payload to Backend:", orderData);

      // --- 2. CALL YOUR BACKEND ---
      const response = await axios.post(
        endPoint.PLACEORDER,
        orderData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Token}`,
          },
        }
      );

      const data = response.data;

      // --- PayU Payment Redirect ---
      if (data?.paymentMode === "PayU" && data?.payuData) {
        redirectToPayU(data.payuData);
        return;
      }

      // --- UPI Payment Redirect (Option 2 / Rangriwaz) ---
      if (data?.paymentMode === "UPI") {
        const upiUrl =
          data?.providerResponse?.payment_url ||
          data?.providerResponse?.data?.upilink;

        if (upiUrl) {
          console.log("🚀 Redirecting to UPI Payment URL:", upiUrl);
          window.location.href = upiUrl;
          return;
        } else {
          toast.error(
            data?.providerResponse?.message ||
              data?.message ||
              "Unable to initiate UPI payment"
          );
          return;
        }
      }

      if (paymentMethod === "PayU") {
        toast.error(data?.message || "Failed to initiate PayU payment");
        return;
      }

      if (paymentMethod === "UPI") {
        toast.error(data?.message || "Failed to initiate UPI payment");
        return;
      }

      // --- 3. HANDLE ONLINE PAYMENT REDIRECT ---

      if (paymentMethod === "Online") {
        const data = response.data;

        if (data?.paymentMode === "REDIRECT" && data?.paymentUrl) {
          console.log("🚀 Redirecting to Easebuzz...");
          window.location.href = data.paymentUrl;
          return;
        }

        if (data?.paymentMode === "POST_FORM" && data?.checkoutUrl) {
          console.log("🚀 Submitting Secure Form to Freecharge...");

          const form = document.createElement("form");
          form.method = "POST";
          form.action = data.checkoutUrl;

          Object.keys(data.payload).forEach((key) => {
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = key;
            input.value = data.payload[key];
            form.appendChild(input);
          });

          document.body.appendChild(form);
          form.submit();
          return;
        }
        console.error("❌ PG Error: Invalid response structure", data);
        toast.error(data.message || "Payment initiation failed");
      }

      else if (paymentMethod === "COD") {
        if (data.message === "Order placed successfully (COD)") {
          localStorage.removeItem("checkoutData");
          toast.success("🎉 Order placed successfully!");
          window.location.assign("/ThankYouPage");
        } else {
          toast.error(data.message || "Order failed");
        }
      }

    } catch (error) {
      console.error("💥 Error in placing order:", error);
      const errorMsg = error.response?.data?.message || "An unexpected error occurred.";
      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const storedCheckoutData = JSON.parse(localStorage.getItem("checkoutData"));
    if (storedCheckoutData) {
      setCheckoutData(storedCheckoutData);
    }
  }, []);

  // 🚀 Sahi check: LocalStorage mein checkoutData ya cart ka data check karein
  useEffect(() => {
    const handlePageShow = () => {
      const storedCheckoutData = localStorage.getItem("checkoutData");
      if (!storedCheckoutData) {
        setIsNotProcessed(true);
      } else {
        setIsNotProcessed(false);
      }
    };

    const storedCheckoutData = localStorage.getItem("checkoutData");
    if (!storedCheckoutData) {
      setIsNotProcessed(true);
    } else {
      setCheckoutData(JSON.parse(storedCheckoutData));
    }

    window.addEventListener("pageshow", handlePageShow);
    return () => {
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, []);


  if (isNotProcessed) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 px-4">
        <div className="bg-white p-8 rounded-2xl shadow-xl max-w-md w-full text-center border border-gray-200">
          <div className="text-orange-500 text-5xl mb-4">🛒</div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Please Proceed to Checkout</h2>
          <p className="text-gray-600 mb-6">
            Your cart has been updated. Please go to your cart, proceed to checkout, and confirm the items.
          </p>
          <button
            onClick={() => navigate("/cart", { replace: true })}
            className="w-full py-3 bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition duration-300 shadow-md"
          >
            Go to Cart
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 py-10 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-semibold text-gray-800 text-center mb-8">
          My Addresses
        </h1>

        {addresses.length === 0 ? (
          <p className="text-lg text-gray-600 text-center">
            You have no saved addresses.
          </p>
        ) : (
          <div className="space-y-6">
            {addresses.map((address) => (
              <div
                key={address._id}
                className="bg-white p-6 rounded-xl shadow-lg border border-gray-300 hover:shadow-xl transition duration-300 ease-in-out"
              >
                <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center">
                  <div>
                    <h3 className="text-xl font-semibold text-gray-800">
                      {address.name}
                    </h3>
                    <p className="text-gray-500 text-sm capitalize">
                      {address.type} Address
                    </p>
                  </div>
                </div>

                <div className="mt-4 space-y-2 text-sm text-gray-600">
                  <p>
                    {address.location}, {address.city}
                  </p>
                  <p>
                    {address.state} - {address.pincode}
                  </p>
                  <p>📞 {address.phone}</p>
                  <p>📧 {address.email.replace("mailto:", "")}</p>
                  <p>🚚 Estimated delivery: {address.deliveryDays} days</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      {checkoutData && (
        <div className="max-w-4xl mx-auto mt-12 p-6 bg-white rounded-xl shadow-lg border border-gray-300">
          <h2 className="text-2xl font-bold mb-6 text-gray-800 text-center">
            Checkout Summary
          </h2>
          <p className="text-gray-700 mb-2">
            Order ID:{" "}
            <span className="font-semibold">{checkoutData?.orderID}</span>
          </p>

          {checkoutData.orderItems && checkoutData.orderItems.length > 0 && (
            <div className="mt-4 space-y-4">
              {checkoutData.orderItems.map((item, index) => (
                <div key={index} className="border p-4 rounded-lg">
                  <p className="text-lg font-semibold text-gray-800">
                    Title:
                    {item.title}
                  </p>

                  <p className=" text-black flex flex-row item-center gap-2">
                    <h4 className="text-left font-bold">Size :- </h4>
                    {item.size}
                  </p>

                  <p className=" text-gray-500 ">
                    <h4 className="text-left font-bold">Description:</h4>
                    {item.description}
                  </p>

                  <p className="text-gray-600">Quantity: {item.quantity}</p>
                  <p className="text-gray-600">
                    Price: ₹{item.selectedVariation?.price || item.totalPrice}
                  </p>
                </div>
              ))}
              <p className="text-gray-700 mb-2">
                Shipping Cost :{" "}
                <span className="font-semibold">₹{shippingCost}</span>
              </p>{" "}
              <p className="text-gray-700 mb-2">
                Total Price:{" "}
                <span className="font-semibold">
                  ₹{checkoutData?.totalPrice + shippingCost}
                </span>
              </p>
            </div>
          )}
          <div className="mt-6">
            <h3 className="text-lg font-semibold mb-3 text-gray-800">
              Choose Payment Method:
            </h3>

            <div className="flex flex-col sm:flex-row flex-wrap gap-4">
              <label
                className={`flex items-center justify-between w-full sm:w-auto flex-1 min-w-[200px] px-4 py-3 border-2 rounded-lg cursor-pointer transition-all duration-300 ${paymentMethod === "Online"
                  ? "border-orange-500 bg-orange-50 shadow-md"
                  : "border-gray-300 bg-white hover:bg-gray-50"
                  }`}
              >
                <div className="flex items-center space-x-3">
                  <input
                    type="radio"
                    name="payment"
                    value="Online"
                    checked={paymentMethod === "Online"}
                    onChange={(e) => setPaymentMethod(e.target.value)}
                    className="accent-orange-500 w-5 h-5"
                  />
                  <span
                    className={`font-medium ${paymentMethod === "Online" ? "text-orange-600" : "text-gray-700"
                      }`}
                  >
                    Pay with Dhankubera (UPI/Card/Net Banking)
                  </span>
                </div>
              </label>


              <label
                className={`flex items-center justify-between w-full sm:w-auto flex-1 min-w-[200px] px-4 py-3 border-2 rounded-lg cursor-pointer transition-all duration-300 ${paymentMethod === "PayU"
                  ? "border-orange-500 bg-orange-50 shadow-md"
                  : "border-gray-300 bg-white hover:bg-gray-50"
                  }`}
              >
                <div className="flex items-center space-x-3">
                  <input
                    type="radio"
                    name="payment"
                    value="PayU"
                    checked={paymentMethod === "PayU"}
                    onChange={() => setPaymentMethod("PayU")}
                    className="accent-orange-500 w-5 h-5"
                  />

                  <span
                    className={`font-medium ${paymentMethod === "PayU"
                      ? "text-orange-600"
                      : "text-gray-700"
                      }`}
                  >
                    Pay with PayU (UPI/Card / Net Banking)
                  </span>
                </div>
              </label>
{/* 
              <label
                className={`flex items-center justify-between w-full sm:w-auto flex-1 min-w-[200px] px-4 py-3 border-2 rounded-lg cursor-pointer transition-all duration-300 ${paymentMethod === "UPI"
                  ? "border-orange-500 bg-orange-50 shadow-md"
                  : "border-gray-300 bg-white hover:bg-gray-50"
                  }`}
              >
                <div className="flex items-center space-x-3">
                  <input
                    type="radio"
                    name="payment"
                    value="UPI"
                    checked={paymentMethod === "UPI"}
                    onChange={() => setPaymentMethod("UPI")}
                    className="accent-orange-500 w-5 h-5"
                  />

                  <span
                    className={`font-medium ${paymentMethod === "UPI"
                      ? "text-orange-600"
                      : "text-gray-700"
                      }`}
                  >
                    Pay with UPI?
                  </span>
                </div>
              </label> */}


              <label
                className={`flex items-center justify-between w-full sm:w-auto flex-1 min-w-[200px] px-4 py-3 border-2 rounded-lg cursor-pointer transition-all duration-300 ${paymentMethod === "COD"
                  ? "border-orange-500 bg-orange-50 shadow-md"
                  : "border-gray-300 bg-white hover:bg-gray-50"
                  }`}
              >
                <div className="flex items-center space-x-3">
                  <input
                    type="radio"
                    name="payment"
                    value="COD"
                    checked={paymentMethod === "COD"}
                    onChange={(e) => setPaymentMethod(e.target.value)}
                    className="accent-orange-500 w-5 h-5"
                  />
                  <span
                    className={`font-medium ${paymentMethod === "COD" ? "text-orange-600" : "text-gray-700"
                      }`}
                  >
                    Cash on Delivery
                  </span>
                </div>
              </label>
            </div>
          </div>

        </div>
      )}

      <div className="relative  mb-20">
        <button
          onClick={handlePlaceOrder}
          className="w-[40%] py-3 bg-orange-500 mt-10 text-white font-semibold rounded-lg hover:bg-orange-600 transition duration-300 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
          disabled={loading}
        >
          {loading ? "Processing..." : "Place Order"}{" "}
        </button>
      </div>
    </div>
  );
}

export default Getaddress;
